export const TODAY = new Date();

export const toISOString = (date = TODAY) => {
  return (
    [
      date.getFullYear(),
      (date.getMonth() + 1).toString().padStart(2, "0"),
      date.getDate().toString().padStart(2, "0"),
    ].join("-") +
    "T" +
    [
      date.getHours().toString().padStart(2, "0"),
      date.getMinutes().toString().padStart(2, "0"),
      date.getMinutes().toString().padStart(2, "0"),
    ].join(":")
  );
};

export const addHours = (numOfHours, date = new Date()) => {
  const rDate = new Date();
  rDate.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);
  return rDate;
};

export const getISOHours = (date) => {
  return toISOString(date).split("T")[1].substring(0, 5);
};

export const parseObjectDate = (date, format = 1) => {
  const meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const weekDay = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];
  let r;
  switch (format) {
    case 1: // DD/MM/YYYY
      r = [
        date.getDate().toString().padStart(2, "0"),
        (date.getMonth() + 1).toString().padStart(2, "0"),
        date.getFullYear(),
      ].join("/");
      break;
    case 2: // Dia Mes YY
      r = [
        date.getDate().toString().padStart(2, "0"),
        meses[date.getMonth()],
        date.getFullYear().toString().substring(2, 4) + "'",
      ].join(" ");
      break;

    case 3: // DD/MM/YYYY, hh:mm A
      r =
        [
          date.getDate().toString().padStart(2, "0"),
          (date.getMonth() + 1).toString().padStart(2, "0"),
          date.getFullYear(),
        ].join("/") +
        ", " +
        date.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        });
      break;
    case 4: // YYYY-MM-DD
      r = [
        date.getFullYear(),
        (date.getMonth() + 1).toString().padStart(2, "0"),
        date.getDate().toString().padStart(2, "0"),
      ].join("-");
      break;
    case 5: // weekDay, Dia de Mes de YYYY
      r =
        [weekDay[date.getDay()]] +
        ", " +
        [
          date.getDate().toString().padStart(2, "0"),
          meses[date.getMonth()],
          date.getFullYear(),
        ].join(" de ");
      break;
    default:
  }
  return r;
};
